import { useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Globe, Heart, Edit, MapPin, Calendar } from 'lucide-react';
import OceanBackground from '@/components/background/OceanBackground';

const tabs = ['全部', '热门', '关注', '我的'];

const mockList = [
  { id: 1, title: '大理的慢时光：在洱海边发呆的七天', author: '旅行家小王', avatar: 'https://picsum.photos/seed/avatar/100/100', cover: 'dali,lake', destination: '大理', likes: 342, collects: 56, date: '2024-01-15' },
  { id: 2, title: '成都美食地图：三天吃遍三十家店', author: '吃货阿喵', cover: 'chengdu,hotpot', destination: '成都', likes: 856, collects: 120, date: '2024-01-10' },
  { id: 3, title: '西藏朝圣：一个人的转山之旅', author: '山野行者', cover: 'tibet,mountain', destination: '拉萨', likes: 620, collects: 89, date: '2024-01-05' },
];

const Travelogues = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative" style={{ background: 'linear-gradient(180deg, #041426 0%, #061A2C 50%, #041426 100%)' }}>
      <Navbar />
      <OceanBackground />
      <div className="max-w-6xl mx-auto px-4 md:px-6 pt-28 pb-20 relative z-10">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-3xl font-bold text-text-primary">旅行游记</h1>
            <p className="text-text-secondary mt-1">发现别人的旅途故事</p>
          </div>
          <Button onClick={() => navigate('/travelogues/new')} className="bg-primary hover:bg-primary-hover text-white rounded-btn px-5 shadow-btn">
            <Edit className="w-4 h-4 mr-2" /> 发布游记
          </Button>
        </div>

        <Tabs defaultValue="全部" className="mb-6">
          <TabsList className="bg-white rounded-btn p-1 shadow-card">
            {tabs.map((t) => <TabsTrigger key={t} value={t} className="rounded-btn px-4 data-[state=active]:bg-primary data-[state=active]:text-white">{t}</TabsTrigger>)}
          </TabsList>
        </Tabs>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {mockList.map((item) => (
            <Card key={item.id} className="border-0 shadow-card rounded-card bg-white overflow-hidden hover:shadow-hover hover:-translate-y-1 transition-all cursor-pointer" onClick={() => navigate(`/travelogue/${item.id}`)}>
              <div className="aspect-video bg-bg-secondary relative">
                <img src={`https://picsum.photos/seed/${item.cover}/600/340`} alt="" className="w-full h-full mx-auto object-cover" />
                {!item.cover && <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-accent/20" />}
              </div>
              <CardContent className="p-4">
                <h3 className="font-semibold text-text-primary line-clamp-2 mb-3 min-h-[3rem]">{item.title}</h3>
                <div className="flex items-center gap-2 mb-3">
                  <img src={item.avatar} alt="" className="w-6 h-6 rounded-full object-cover" />
                  <span className="text-xs text-text-secondary">{item.author}</span>
                </div>
                <div className="flex items-center justify-between text-xs text-text-tertiary">
                  <Badge variant="secondary" className="bg-primary-light text-primary rounded-full text-[10px]"><MapPin className="w-3 h-3 mr-1" />{item.destination}</Badge>
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1"><Heart className="w-3 h-3" /> {item.likes}</span>
                    <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {item.date}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Travelogues;
